import axios from 'axios';
import Vue from 'vue';
import OFFICE_TYPES from '@/models/officeType'; // так настроили обработку ошибок запросов */

/* eslint-disable camelcase */
/* eslint-disable no-throw-literal */ export default class API {
  /**
   * @param baseURL
   * @param store
   */
  constructor({ baseURL, store }) {
    this.axios = axios.create({ baseURL });
    this.store = store;
  }

  /**
   * Создание экземпляра API
   * @param baseURL
   * @param store
   * @return {API}
   */
  static createApi({ baseURL, store }) {
    return new API({
      baseURL,
      store,
    });
  }

  /**
   *
   * @param url
   * @param method
   * @param params
   * @returns {AxiosPromise<any>}
   */
  requestCore(url, method, params) {
    try {
      return this.axios.request({
        url,
        method,
        data: params,
      });
    } catch (error) {
      this.errorHandler(error, url);
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  }

  /**
   * базовый метод запроса через axios
   * @param url
   * @param method
   * @param params
   * @return {Promise<*>}
   */
  async request(url, method, params) {
    try {
      const response = await this.requestCore(url, method, params);
      const { data } = response;

      if (data.errors && data.errors.length > 0) {
        throw {
          message: data.errors[0].Message,
          code: data.errors[0].Code,
        };
      }

      if (!data.success) {
        return response.status;
      } return data.success;
    } catch (error) {
      this.errorHandler(error, url);
      return false;
    }
  }

  /**
   *
   * @param arrAxiosPromise {[AxiosPromise<any>]}
   * @returns {Promise<*>}
   */
  // eslint-disable-next-line class-methods-use-this
  async requestAll(arrAxiosRequest) {
    try {
      const dataFromRequest = await axios.all(arrAxiosRequest);

      const arrRrrorCode = [];
      const arrRrrorMessage = [];
      dataFromRequest.forEach((item) => {
        if (item.data.errors && item.data.errors.length > 0) {
          const { Code, Message } = item.data.errors[0];
          arrRrrorCode.push(Code);
          arrRrrorMessage.push(Message);
        }
      });

      if (arrRrrorCode.length > 0 || arrRrrorMessage.length > 0) {
        throw {
          code: arrRrrorCode.join(' && '),
          message: arrRrrorMessage.join(' && '),
        };
      }

      return dataFromRequest;
    } catch (error) {
      this.errorHandler(error);
      return false;
    }
  }

  /**
   * Обработчик ошибок запросов сети
   * @param error
   * @param url
   */
  errorHandler(error, url = '') {
    this.store.dispatch('api/setError', { ...error });
    this.store.dispatch('api/setErrorUrl', url);
    throw error;
  }

  /**
   * Получении сессии на сервере API
   */
  async authorize() {
    const { sessionId: storedSessionId } = this.store.state.api;
    const sessionRegexp = new RegExp('^[a-f0-9]{32}$', 'i');
    if (storedSessionId) {
      if (!sessionRegexp.test(storedSessionId)) {
        const senderId = 'authorize.sessionStorage';
        Vue.statisticService.pushErrorMassage(senderId, {
          senderId,
          date: new Date(),
          gotSession: storedSessionId,
          sourceSession: sessionStorage
            ? sessionStorage.getItem('sessionAppId')
            : null,
        });
      }
      return Promise.resolve(storedSessionId);
    }
    try {
      const { session_id: sessionId } = await this.request(
        'api/authorize',
        'POST',
        {},
      );
      if (!sessionRegexp.test(sessionId)) {
        const senderId = 'authorize.api';
        Vue.statisticService.pushErrorMassage(senderId, {
          senderId,
          date: new Date(),
          gotSession: sessionId,
        });
      }
      this.store.dispatch('api/setSessionId', sessionId);
      return Promise.resolve(sessionId);
    } catch (error) {
      // this.errorHandler(error, 'api/setSessionId');
      return false;
    }
  }

  /**
   *
   * @returns {Promise<*>}
   */
  async getSettings() {
    try {
      const settings = await this.request('api/getSettings', 'POST', {});
      if (settings) {
        sessionStorage.setItem('sessionSettings', JSON.stringify(settings));
      }
      return Promise.resolve(settings);
    } catch (error) {
      throw error;
    }
  }

  /**
   * Автопоиск при заполнении
   * @param city
   * @param countryCode
   * @param searchString
   * @param requestedEntity
   * @param maxCount
   * @return {Promise<void>}
   */
  autocomplete({
    isShipper = false,
    city,
    countryCode,
    searchString,
    requestedEntity,
    maxCount = 100,
  }) {
    const data = {
      isShipper: isShipper === true ? 1 : null,
      city,
      country_code: countryCode || null,
      max_count: maxCount,
      requested_entity: requestedEntity,
      search_string: searchString || '',
    };
    return this.request('api/autocomplete', 'POST', data);
  }

  calculatePickupRanges({
    cityFrom,
    countryCodeFrom,
    postalCodeFrom,
    cityTo,
    countryCodeTo,
    postalCodeTo,
    windowsTimeZoneId,
    date,
  }) {
    if (
      [
        cityFrom,
        countryCodeFrom,
        cityTo,
        countryCodeTo,
        windowsTimeZoneId,
        date,
      ].some((f) => !f)
    ) {
      throw new Error('Не все данные заполнены');
    }

    const [dateString] = date.toISOString().split('T');

    const data = {
      city_from: cityFrom,
      country_code_from: countryCodeFrom,
      postal_code_from: postalCodeFrom,
      city_to: cityTo,
      country_code_to: countryCodeTo,
      postal_code_to: postalCodeTo,
      windows_time_zone_id: windowsTimeZoneId,
      date: dateString,
    };

    return this.request('api/calculatePickupRanges', 'POST', data);
  }

  /**
   * Метод для получения данных о доступных для приема груза праздничных и выходных днях
   * В ответе возвращается масси объектов, пример:
   * [{
   *   "Date": "2020-10-03",
   *   "DayType": 1,
   *   "From": "12:00",
   *   "DeadLine": "14:30",
   *   "To": "17:00"
   * },...]
   * где Date - дата,
   * DayType - тип дня
   *    0 - рабочий день (рабочая суббота, например),
   *    1 - суббота,
   *    2 - праздник или воскресенье
   * From - начало интервала, после PickupWindowEarliestTime
   * To - конец интервала, после PickupWindowEarliestTime
   * DeadLine - время до которого можно оформить заявку. После BookingTime из ответа
   * @param localFrom
   * @param localTo
   * @param date - дата в формате "2020-09-29"
   * @param timeZone - временная зона в формате "Russian Standard Time"
   * @returns {Promise<*>}
   */
  calculatePickupRangesForWeekends({ localFrom, localTo, date, timeZone }) {
    const { cityFrom, countryCodeFrom, postalCodeFrom } = localFrom;
    const { cityTo, countryCodeTo, postalCodeTo } = localTo;

    const checkArr = [
      cityFrom,
      countryCodeFrom,
      cityTo,
      countryCodeTo,
      date,
      timeZone,
    ];
    if (checkArr.some((f) => !f)) {
      throw new Error('Не все данные заполнены');
    }

    const data = {
      city_from: cityFrom,
      country_code_from: countryCodeFrom,
      postal_code_from: postalCodeFrom || null,
      city_to: cityTo,
      country_code_to: countryCodeTo,
      postal_code_to: postalCodeTo || null,
      windows_time_zone_id: timeZone,
      date,
    };

    return this.request('api/CalculatePickupRangesForWeekends', 'POST', data);
  }

  /**
   * Получение ближайших точек
   * @return {Promise<*[]>}
   */
  async getServicePoints({ locationFrom, locationTo }) {
    let nearest = null;

    if (locationFrom && !(locationFrom.PostalCode || locationFrom.autoPostal)) {
      return [];
    }

    if (locationFrom && locationTo) {
      const {
        DctCityName: city_from,
        CountryCode: country_code_from,
        PostalCode: postal_code_from,
        FacilityCode: facility_from,
        autoPostal,
      } = this.changePostfixNeeded(locationFrom);

      const {
        DctCityName: city_to,
        CountryCode: country_code_to,
        PostalCode: postal_code_to,
      } = this.changePostfixNeeded(locationTo);

      nearest = {
        city_from,
        city_to,
        country_code_from,
        country_code_to,
        postal_code_from: postal_code_from || autoPostal,
        postal_code_to,
        facility_from,
      };
    }

    const dataPoints = {
      max_count: 0,
      nearest,
    };
    const dataDesks = {
      max_count: 0,
      nearest: nearest || {},
    };

    const promisePoints = this.requestCore(
      'api/getOfficesWithoutServiceDesks',
      'POST',
      dataPoints,
    );
    const promiseDesks = this.requestCore(
      'api/getServiceDesks',
      'POST',
      dataDesks,
    );
    const responseFromServer = await this.requestAll([
      promisePoints,
      promiseDesks,
    ]);

    return responseFromServer.reduce((servicePoints, currentValue) => {
      const { success } = currentValue.data;
      if (!success) return [];
      return servicePoints.concat(
        success.map((point) => {
          const { officeType } = point;
          const isServicePoint = officeType === OFFICE_TYPES.SERVICE_POINT;
          const isAgency = officeType === OFFICE_TYPES.AGENCY;
          const isServiceDeskExpressEasy =
            officeType === OFFICE_TYPES.SERVICE_DESK_EXPRESS_EASY;
          const isServiceDeskFullScope =
            officeType === OFFICE_TYPES.SERVICE_DESK_FULL_SCOPE;
          return {
            ...point,
            isServicePoint,
            isAgency,
            isServiceDeskExpressEasy,
            isServiceDeskFullScope,
          };
        }),
      );
    }, []);
  }

  async processShipment(data) {
    return this.request('api/processShipment', 'POST', data);
  }

  async getServiceDeskRequestCode(data) {
    return this.request('api/getServiceDeskRequestCode', 'POST', data);
  }

  async getSalTaxGoods() {
    try {
      const countryCode = this.store.state.preparation.locationTo.CountryCode;

      return this.request('api/GetSalTaxGoods', 'POST', {
        country_code: countryCode,
      });
    } catch (e) {
      this.errorHandler(e, 'api/GetSalTaxGoods');
      return Promise.reject(e);
    }
  }

  async getOrderStatus(data) {
    return this.request('api/getOrderStatus', 'POST', data);
  }

  async cancelledPayment(data) {
    return this.request('api/CancelledPayment', 'POST', data);
  }

  async getPaymentInfo(data) {
    return this.request('api/PaymentsReader', 'POST', data);
  }

  // eslint-disable-next-line class-methods-use-this
  changePostfixNeeded(local) {
    let postalCode = local.PostalCode || local.autoPostal;
    if (local.PostfixNeeded === 1) {
      postalCode += local.Postfix;
    }

    return {
      ...local,
      PostalCode: postalCode,
    };
  }
}
